import React from 'react';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Box, Grid, Button } from '@mui/material';
import { postRequest } from 'Includes/api/apicall';
import { POST_URL } from 'Includes/urls';
import { Link } from 'react-router-dom';
import { AddCircleOutlineOutlined } from "@mui/icons-material";
import { Dropdown } from 'Components/DropDown';
import Swal from 'sweetalert2'


const commandList = [
    { id: 'all', name: 'All' },
    { id: 'uploadurl', name: 'Upload URL' },
    { id: 'reload', name: 'Reload' },
    { id: 'gitpull', name: 'Git Pull' },
]

function ServerUpdate(props) {

    const [command, setCommand] = React.useState('all');
    const [fieldErrors, setFieldErrors] = React.useState({});
    const [submitDisable, setSubmitDisable] = React.useState(false);

    const handleChange = (e) => {
        let { value } = e.target;
        setCommand(() => value)
        let fieldErrors={}
        setFieldErrors(() => fieldErrors)
    }

    const submit=()=>{
        setSubmitDisable(()=>true)
        let post_data={
            "command":command
        }
        const url = POST_URL.servercommand.api
        postRequest(url, post_data, {}).then(response => {
          if (response && response.status === 200) {
            const Response = response.data
            Swal.fire({
              position: 'top-end',
              type: 'success',
              title: Response.Reason,
              text: 'School Information is Updated ',
              showConfirmButton: false,
              timer: 1500
            })
          }
        setSubmitDisable(()=>false)
        })
    }   

    return (
        <Box>
            <Grid container>
                <Grid item md={3}>
                    <Dropdown
                        data={commandList}
                        name={'command'}
                        value={command}
                        onChange={(e) => handleChange(e)}
                        error={fieldErrors['command']}
                        label={'Operation'}
                        hideSelect={true}
                    />
                </Grid>
                <Grid item md={3}>
                    <Box className='mv-10'>
                        <Button variant='contained'
                            color='primary' className='submit'
                            disabled={submitDisable}
                            onClick={submit}>
                            Submit
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )

}

export default ServerUpdate;